import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';
import { crearDepurador } from '../utils/depurador';

interface Escala {
  anio: string;
  mes: string;
  monto: number;
}

// Crear un depurador específico para el módulo de Escalas
const depurador = crearDepurador({ modulo: 'Escalas' });

export default function Escalas() {
  const [escalas, setEscalas] = useState<Escala[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEscalas = async () => {
      try {
        const response = await apiClient.get('/api/escala');
        setEscalas(response.data);
        setLoading(false);
      } catch (err: any) {
        depurador.grupo('Error al cargar escalas');
        depurador.error('Error completo:', err);
        depurador.error('Mensaje de error:', err.message);
        depurador.error('Response:', err.response);
        depurador.finGrupo();
        setError('Error al cargar las escalas');
        setLoading(false);
      }
    };

    fetchEscalas();
  }, []);

  const formatMonto = (monto: number) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS'
    }).format(monto);
  };

  const getNombreMes = (mes: string) => {
    const meses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    return meses[parseInt(mes) - 1];
  };

  if (loading) return <div className="flex justify-center items-center h-screen">Cargando...</div>;
  if (error) return <div className="text-red-500 text-center p-4">{error}</div>;

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Escala Ley 14283</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 border">Año</th>
              <th className="px-4 py-2 border">Mes</th>
              <th className="px-4 py-2 border">Monto</th>
            </tr>
          </thead>
          <tbody>
            {escalas.map((escala, index) => (
              <tr key={`${escala.anio}-${escala.mes}`} className="hover:bg-gray-50">
                <td className="px-4 py-2 border text-center">{escala.anio}</td>
                <td className="px-4 py-2 border">{getNombreMes(escala.mes)}</td>
                <td className="px-4 py-2 border text-right">{formatMonto(escala.monto)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}